import { IconProps, SvgIcon } from "@mui/material";

const PhoneIcon = ({ sx }: IconProps) => {
  return (
    <SvgIcon sx={sx}>
      <svg viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.2448 15.3505C12.4415 15.4408 12.6631 15.4615 12.873 15.409C13.083 15.3565 13.2689 15.2341 13.4 15.0619L13.7381 14.6191C13.9155 14.3825 14.1456 14.1905 14.4101 14.0582C14.6746 13.926 14.9662 13.8571 15.2619 13.8571H18.1191C18.6242 13.8571 19.1087 14.0578 19.4659 14.415C19.8231 14.7723 20.0238 15.2567 20.0238 15.7619V18.6191C20.0238 19.1242 19.8231 19.6087 19.4659 19.9659C19.1087 20.3231 18.6242 20.5238 18.1191 20.5238C13.5725 20.5238 9.21213 18.7177 5.99722 15.5028C2.78231 12.2879 0.976196 7.92753 0.976196 3.38096C0.976196 2.87578 1.17688 2.3913 1.53409 2.03409C1.8913 1.67688 2.37578 1.4762 2.88096 1.4762H5.7381C6.24328 1.4762 6.72776 1.67688 7.08497 2.03409C7.44218 2.3913 7.64286 2.87578 7.64286 3.38096V6.2381C7.64286 6.53381 7.57402 6.82545 7.44177 7.08994C7.30953 7.35442 7.11752 7.58449 6.88096 7.76191L6.43524 8.0962C6.2604 8.2297 6.13717 8.41961 6.08647 8.63367C6.03578 8.84773 6.06075 9.07274 6.15715 9.27048C7.45875 11.9142 9.59946 14.0522 12.2448 15.3505Z"
          stroke="#0D579B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default PhoneIcon;
